import React, { useEffect, useState } from 'react';
import logo from '../../../assets/website/images/logo_r.svg';
import twitter from '../../../assets/website/images/twitter.svg';
import insta from '../../../assets/website/images/insta.svg';
import facebook from '../../../assets/website/images/facebook.svg';
import youtube from '../../../assets/website/images/youtube.svg';
import { Link, useLocation } from 'react-router-dom';
import downloadBabeAppImage from '../../../assets/website/images/download-babe-app-img-1.png';
import footerShape from '../../../assets/website/images/footer-watermark.png';
import googlePlayImage from '../../../assets/website/images/google-play-image.png';
import appStoreImage from '../../../assets/website/images/app-store-image.png';
import * as commonServices from '../services/website.services';
import { CMS_PAGES_POSITIONS } from '../../../utils/Constants';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { capitalizeFirstLetter } from '../../../utils/commonfunction';
import toHtml from 'html-react-parser';

const WebsiteFooter = () => {

  const [companyMenuData, setCompanyMenuData] = useState([]);
  const [impMenuData, setImpMenuData] = useState([]);
  const [getGlobalData, setGlobalData] = useState({});
  const myGlobalData = useSelector((state) => state.globalData);

  useEffect(() => {
    if (myGlobalData && myGlobalData?.data) {
      const settingsData = JSON.parse(myGlobalData?.data);
      setGlobalData(settingsData);
    }
  }, [myGlobalData]);

  useEffect(() => {
    commonServices.menuOptions({ menu_location: CMS_PAGES_POSITIONS.FOOTER }).then((response) => {
      let companyMenu = [];
      let linksMenu = [];
      response?.data?.forEach(element => {
        if (element.footer_menu_name === 'company') {
          companyMenu.push(element);
        } else {
          linksMenu.push(element);
        }
      });
      // setCompanyMenuData(companyMenu);
      setImpMenuData(linksMenu);
    }).catch((error) => {
      console.log("error", error);
    });
  }, []);


  return (
    <footer>
      <section className="babe-app " id="get-app">
        <div className="container">
          <div className="container-box-2">
            <div className="row row-gap-5">
              <div className="col-md-6">
                <figure>
                  <img src={downloadBabeAppImage}
                    alt="download our App"
                  />
                </figure>
              </div>
              <div className="col-md-6">
                <div className="download-box">
                  <span className="subheading ink">the babe. app</span>
                  <h2 className="h2 text-white">download the <br /> babe. app</h2>
                  {/* <h5 className="h5-headline mb-3">
                    Everything you need, right at your fingertips
                  </h5> */}
                  <p className="ink">
                    Whether you're scheduling a fertility injection, booking a
                    night nanny, or just need a moment to breathe—we’re here.
                    The babe app puts expert support in your pocket, 24/7.
                  </p>
                  {/* <div className="store-image">
                    <a target={"_blank"} href={getGlobalData?.play_store_url}>
                      <img src={googlePlayImage} alt="google play icon" />
                    </a>
                    <a target={"_blank"} href={getGlobalData?.app_store_url}>
                      <img src={appStoreImage} alt="app store icon" />
                    </a>
                  </div> */}
                  <div className="store-badges">
                    <a
                      href={getGlobalData?.app_store_url || '#'}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn_2 decoration-none"
                    >
                      <span>COMING SOON</span>
                      <span>App Store</span>
                    </a>
                    <a
                      href={getGlobalData?.play_store_url || '#'}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn_2 decoration-none"
                    >
                      <span>COMING SOON</span>
                      <span>Google Play</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>





      <div className="footer-padding position-relative">
        <div className="footer-shape">
          <img src={footerShape} alt="footer shape" className='w-100 h-100 object-fit-cover' />
        </div>
        <div className="container-fluid">

          <div className="footer-top">
            <div className='row row-gap-4'>
              <div className="col-md-6">
                <div className="footer-logo">
                  <Link to="/">
                    <img src={logo} alt='babe' />
                  </Link>
                  <p className="ink">supporting women at every stage. because, babe, it ain't easy.™</p>

                </div>
              </div>
              <div className="col-md-6">
                <div className='row '>
                  <div className='col-xl-5 col-lg-7 col-md-8 col-sm-8 col-10'>
                    <div className="d-flex justify-content-between">
                      <div className="footer-item">
                        <h5 className="h5-headline">company</h5>
                        <ul className="d-flex gap-1 flex-column">
                          {/* <li className="subtitle-1"><a href="/">Our Story</a></li> */}
                          {/* <li className=" subtitle-1"><Link className="nav-link" to="/meetTheFounder">Meet the Founders</Link></li> */}
                          <li><Link className="subtitle-2" to="/frequentlyAskedQuestions">faq's</Link></li>
                          {impMenuData && impMenuData.length > 0 &&
                            impMenuData.map((item, index) => (
                              <li>
                                <Link key={index} to={`/org-info/${item?.slug}`} className="subtitle-2">
                                  {item?.title}
                                </Link>
                              </li>
                            ))
                          }
                        </ul>
                      </div>

                      <div className="footer-item">
                        {getGlobalData?.social_media_details ?
                          <>
                            <h5 className="h5-headline">connect</h5>
                            <ul className="d-flex gap-1 flex-column cp">
                              {getGlobalData?.social_media_details.map((item, index) => (
                                <li key={index} className="subtitle-2">
                                  <a href={item?.link} target="_blank" rel="noreferrer">
                                    {/* {toHtml(item?.icon)} */}
                                    {item?.title}
                                  </a>
                                </li>
                              ))
                              }
                              <li><Link className="subtitle-2" to="/contact-us">contact us</Link></li>
                            </ul>
                          </> : <></>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div className="footer-bottom d-flex footer-item-padding justify-content-between">
            <div className="ink">
              {capitalizeFirstLetter(getGlobalData?.copy_right_text)}
            </div>

          </div>
        </div>
      </div>
    </footer >
  )
}

export default WebsiteFooter;
